import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import HistoryView from '@/views/HistoryView.vue';
import ProfileView from '@/views/ProfileView.vue';
import CreateVideoView from '@/views/CreateVideoView.vue';
import CreateImageView from '@/views/CreateImageView.vue';
import GenerationView from '@/views/GenerationView.vue';
import TopupView from '@/views/TopupView.vue';
import TopupSuccessView from '@/views/TopupSuccessView.vue';
import TopupFailView from '@/views/TopupFailView.vue';
import IdeasView from '@/views/IdeasView.vue';
import OnboardingView from '@/views/OnboardingView.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import { backButton } from '@/composables/useTelegramWebApp';
import { isOnboarded } from '@/composables/useOnboarding';

export const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/history', name: 'history', component: HistoryView },
    { path: '/ideas', name: 'ideas', component: IdeasView },
    { path: '/onboarding', name: 'onboarding', component: OnboardingView, meta: { showTabs: false } },
    { path: '/profile', name: 'profile', component: ProfileView },
    { path: '/create/video', name: 'create-video', component: CreateVideoView },
    { path: '/create/image', name: 'create-image', component: CreateImageView },
    {
      path: '/generation/:id',
      name: 'generation',
      component: GenerationView,
      meta: { showTabs: false, backButton: true },
    },
    { path: '/topup', name: 'topup', component: TopupView, meta: { backButton: true } },
    {
      path: '/topup/success',
      name: 'topup-success',
      component: TopupSuccessView,
      meta: { showTabs: false, backButton: true },
    },
    {
      path: '/topup/fail',
      name: 'topup-fail',
      component: TopupFailView,
      meta: { showTabs: false, backButton: true },
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView },
  ],
});

// First-run redirect: на корне без флага onboarding — увести на /onboarding
// до того как HomeView успеет смонтироваться и сходить за /me, /models, etc.
router.beforeEach((to, _from, next) => {
  if (to.path === '/' && !isOnboarded()) {
    next('/onboarding');
    return;
  }
  next();
});

// View transition for navigations between top-level routes.
router.beforeEach((to, from, next) => {
  if (typeof (document as any).startViewTransition !== 'function') {
    next();
    return;
  }
  if (from.name && to.name && to.name !== from.name) {
    (document as any).startViewTransition(() => {
      next();
    });
  } else {
    next();
  }
});

// BackButton wiring — show on routes with meta.backButton, hide otherwise.
// Tracks whether we've navigated within the SPA so we can fall back to "/"
// when there's nowhere to go back to (e.g. the user opened a Mini App link
// straight to /generation/:id and back() would be a no-op).
let _internalNavCount = 0;
router.afterEach((to, from) => {
  if (from.name) _internalNavCount++;
  if (to.meta?.backButton) {
    backButton.show(() => {
      if (_internalNavCount > 0) {
        router.back();
      } else {
        // No SPA history yet — go to home instead of stranding the user.
        router.push('/');
      }
    });
  } else {
    backButton.hide();
  }
});
